{
  "$id": "wealthlane://forms/tax-period/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": [
    {
      "id": "rule_effectiveFrom_before_effectiveTill",
      "target": "effectiveFrom",
      "rule": "custom",
      "customId": "taxPeriodStartBeforeEnd",
      "message": "Start date must be before end date",
      "condition": {
        "allOf": [
          { "field": "effectiveFrom", "notEmpty": true },
          { "field": "effectiveTill", "notEmpty": true }
        ]
      }
    },
    {
      "id": "rule_effectiveTill_after_effectiveFrom",
      "target": "effectiveTill",
      "rule": "custom",
      "customId": "taxPeriodEndAfterStart",
      "message": "End date must be after start date",
      "condition": {
        "allOf": [
          { "field": "effectiveFrom", "notEmpty": true },
          { "field": "effectiveTill", "notEmpty": true }
        ]
      }
    }
  ]
}
